(function() {
  function getSubtotalFromCart(cart) {
    var total = 0;
    if (cart && cart.items) {
      cart.items.forEach(function(item) {
        total += (item.original_line_price || 0);
      });
    }
    return total;
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  function updateBanner(banner, subtotal) {
    if (!banner) return;
    var textEl = banner.querySelector('.ec-free-shipping-banner__text');
    var progress = banner.querySelector('.ec-free-shipping-banner__progress');
    var thresholdSp = parseInt(banner.getAttribute('data-threshold-sp') || '25000', 10);
    var thresholdBr = parseInt(banner.getAttribute('data-threshold-br') || '39900', 10);

    if (subtotal >= thresholdBr) {
      if (textEl) textEl.innerHTML = '<strong>Parabéns</strong>, você ganhou frete grátis para todo Brasil!';
      if (progress) progress.style.width = '100%';
      banner.classList.add('ec-free-shipping-banner--achieved');
    } else if (subtotal >= thresholdSp) {
      var remainingBr = thresholdBr - subtotal;
      if (textEl) textEl.innerHTML = '<strong>Parabéns!</strong> Frete grátis para SP Capital.<br>Faltam <strong>' + formatMoney(remainingBr) + '</strong> para frete grátis em todo Brasil!';
      if (progress) progress.style.width = Math.min(100, (subtotal * 100 / thresholdBr)) + '%';
      banner.classList.add('ec-free-shipping-banner--achieved');
    } else {
      var remainingSp = thresholdSp - subtotal;
      var remainingBr = thresholdBr - subtotal
			if (textEl)
				textEl.innerHTML =
					'Faltam <strong>' +
					formatMoney(remainingSp) +
					'</strong> para Frete Grátis SP Capital ou <strong>' +
					formatMoney(remainingBr) +
					'</strong> para todo Brasil!'
      if (progress) progress.style.width = Math.min(100, (subtotal * 100 / thresholdBr)) + '%';
      banner.classList.remove('ec-free-shipping-banner--achieved');
    }
  }

  function updateAllBanners(subtotal) {
    var banners = document.querySelectorAll('.ec-free-shipping-banner');
    banners.forEach(function(banner) {
      updateBanner(banner, subtotal);
    });
  }

  document.addEventListener('cart:updated', function(e) {
    var cart = e && e.detail;
    var subtotal = cart ? getSubtotalFromCart(cart) : 0;
    if (subtotal === 0) {
      var totalEl = document.querySelector('.ec-cart-footer__total-value');
      if (totalEl) subtotal = parseInt(totalEl.getAttribute('data-cart-subtotal') || totalEl.getAttribute('data-cart-subtotal-sem-desconto') || '0', 10);
    }
    updateAllBanners(subtotal);
  });

  function initBanners() {
    var banners = document.querySelectorAll('.ec-free-shipping-banner');
    banners.forEach(function(banner) {
      var subtotal = parseInt(banner.getAttribute('data-subtotal') || '0', 10);
      var totalEl = banner.closest('cart-drawer') ? banner.closest('cart-drawer').querySelector('.ec-cart-footer__total-value') : document.querySelector('.ec-cart-footer__total-value');
      if (totalEl) subtotal = parseInt(totalEl.getAttribute('data-cart-subtotal') || totalEl.getAttribute('data-cart-subtotal-sem-desconto') || '0', 10);
      updateBanner(banner, subtotal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBanners);
  } else {
    initBanners();
  }
})();
